export function ListItemThirdIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 1.875C5.5125 1.875 1.875 5.5125 1.875 10C1.875 14.4875 5.5125 18.125
        10 18.125C14.4875 18.125 18.125 14.4875 18.125 10C18.125 5.5125 14.4875 1.875
        10 1.875ZM11.8719 13.3481C11.3556 13.8463 10.7131 14.0944 9.94313 14.0944C9.21438
        14.0944 8.61 13.885 8.13062 13.4662C7.65 13.0475 7.37187 12.5006 7.295 11.8244L8.78937
        11.6437C8.83687 12.0231 8.965 12.3131 9.17437 12.5144C9.3825 12.715 9.63563 12.8156
        9.9325 12.8156C10.2513 12.8156 10.5194 12.6944 10.7381 12.4519C10.9556 12.21
        11.0644 11.8838 11.0644 11.4731C11.0644 11.085 10.96 10.7763 10.7512 10.5488C10.5419
        10.3213 10.2875 10.2081 9.98688 10.2081C9.78875 10.2081 9.5525 10.2469 9.27688
        10.3231L9.44687 9.075C9.86437 9.08625 10.1831 8.99563 10.4025 8.80375C10.6219
        8.61188 10.7313 8.35688 10.7313 8.03875C10.7313 7.76813 10.6512 7.55312 10.4906
        7.39187C10.3294 7.23125 10.1163 7.15062 9.85 7.15062C9.58688 7.15062 9.36312 7.24187
        9.17687 7.42437C8.99062 7.60687 8.8775 7.87437 8.83687 8.225L7.41125 7.98375C7.51
        7.495 7.65937 7.10438 7.85937 6.81188C8.05937 6.51938 8.3375 6.29 8.69438 6.1225C9.05125
        5.955 9.45187 5.87188 9.895 5.87188C10.6531 5.87188 11.2613 6.11375 11.7188 6.5975C12.0962
        6.99312 12.2844 7.44 12.2844 7.93813C12.2844 8.645 11.8975 9.20938 11.1231 9.63063C11.585
        9.72938 11.9544 9.95125 12.2306 10.295C12.5075 10.6394 12.6456 11.0544 12.6456
        11.5412C12.6462 12.2487 12.3881 12.8506 11.8719 13.3481Z"
        fill="#475569"
      />
    </svg>
  );
}
